import React, { ReactElement } from 'react'
import Icon from '@ant-design/icons'

const ConfirmedSvg = (): ReactElement => (
  <svg viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m0.5 30c0-16.292 13.208-29.5 29.5-29.5s29.5 13.208 29.5 29.5-13.208 29.5-29.5 29.5-29.5-13.208-29.5-29.5z'
      fill='#72C040'
      stroke='#72C040'
    />
    <path
      d='m43.394 19.219h-2.3404c-0.3281 0-0.6395 0.1506-0.8404 0.4084l-13.805 17.488-6.6195-8.3873c-0.1001-0.1272-0.2277-0.23-0.3733-0.3007-0.1455-0.0708-0.3052-0.1076-0.4671-0.1078h-2.3404c-0.2243 0-0.3482 0.2578-0.2109 0.4319l9.1708 11.618c0.4285 0.5424 1.2522 0.5424 1.6841 0l16.353-20.722c0.1373-0.1707 0.0134-0.4285-0.211-0.4285z'
      fill='#fff'
    />
  </svg>
)

export const ConfirmedIcon = (props): ReactElement => <Icon component={ConfirmedSvg} {...props} />
